// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1ALra","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2oyim"};